export default {"src":"/nachrichten/_next/static/media/IconAppleStore.be77017d.svg","height":50,"width":150,"blurWidth":0,"blurHeight":0};